import { USD_DECIMALS } from "config/factors";
import { bigintToNumber } from "lib/numbers";

export const CHART_INVERSE_PRICE_THRESHOLD_USD = 0.01;

export function shouldInvertChartPrice(price?: bigint, decimals: number = USD_DECIMALS): boolean {
  if (price === undefined || price <= 0n) return false;
  const value = bigintToNumber(price, decimals);
  return Number.isFinite(value) && value > 0 && value < CHART_INVERSE_PRICE_THRESHOLD_USD;
}

export function shouldInvertChartPriceNumber(price?: number): boolean {
  if (price === undefined) return false;
  return Number.isFinite(price) && price > 0 && price < CHART_INVERSE_PRICE_THRESHOLD_USD;
}

export function invertUsdPrice(price: bigint, decimals: number = USD_DECIMALS): bigint {
  if (price <= 0n) return price;
  const precision = 10n ** BigInt(decimals);
  return (precision * precision) / price;
}

export function invertUsdPriceNumber(price: number): number {
  return price > 0 ? 1 / price : price;
}
